import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M20.71 3.655s1.942-.758 1.78 1.082c-.053.757-.539 3.409-.917 6.276l-1.295 8.495s-.108 1.245-1.08 1.461c-.97.216-2.428-.758-2.698-.974-.215-.163-4.046-2.598-5.396-3.788-.377-.325-.81-.974.055-1.731l5.665-5.411c.647-.649 1.295-2.164-1.403-.324l-7.555 5.14s-.864.541-2.482.054l-3.508-1.083s-1.295-.811.917-1.623C8.19 8.688 14.827 6.09 20.71 3.655h.001Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }